import { Box, Flex, Heading, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import { Logo } from '@/components/Logo';

interface RingBackgroundPageProps {
  children: React.ReactNode;
  title: string;
}

export const RingBackgroundPage: React.FC<RingBackgroundPageProps> = ({ children, title }) => {
  return (
    <Flex
      align="center"
      bgGradient="linear(to-br, #38899A 25%, #135AA5 50%)"
      h="100vh"
      justify="center"
      w="100%">
      <Box position="absolute" top="4" right="4">
        <LanguageSwitcher buttonTextColor="white" optionTextColor="black" />
      </Box>
      <Box bg="white" mx="auto" p="8" rounded="md" w="full" maxW="400px">
        <Stack direction="row" justify="space-between" align="center" mb="8">
          <Logo w="16" h="16" color="black" />
          <Heading size="md" noOfLines={1} color="blue.500">
            {title}
          </Heading>
        </Stack>
        {children}
      </Box>
    </Flex>
  );
};
